import type { ReactNode } from "react";

type ContainerProps = {
  children: ReactNode;
  className?: string;
  as?: "div" | "section" | "header" | "footer" | "main" | "article";
  /** `content` keeps the tighter reading shell (header / mega menu). */
  width?: "site" | "content";
};

export function Container({
  children,
  className = "",
  as: Tag = "div",
  width = "site",
}: ContainerProps) {
  const widthClass =
    width === "content"
      ? "mx-auto w-full max-w-7xl px-6 md:px-10 lg:px-16"
      : "mx-auto w-full max-w-[1440px] px-6 md:px-10 lg:px-14 xl:px-16";

  return <Tag className={`${widthClass} ${className}`}>{children}</Tag>;
}
